import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as userActions from "../../actions/userActions";
import * as controlPanelActions from "../../actions/controlPanelActions";
import * as authActions from "../../actions/authActions";

const getUserFailLogic = createLogic({
	type: ActionTypes.GET_USER_FAIL,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(controlPanelActions.hideLoading());
		if (action.error.response && action.error.response.status === 401) {
			const isNewUser = localStorage.getItem("newUser");
			localStorage.removeItem("newUser");
			if (isNewUser && isNewUser === "google") {
				var authuser = getState().auth.user;
				var user = {
					firstName: authuser.displayName.split(" ")[0],
					lastName: authuser.displayName.replace(authuser.displayName.split(" ")[0] + " ", ""),
					email: authuser.email,
					timezoneId: "America/Chicago",
				};
				dispatch(userActions.createUser(user));
			} else if (isNewUser && isNewUser === "email") {
				var activateUser = localStorage.getItem("activateUser");
				localStorage.removeItem("activateUser");
				var emailauthuser = getState().auth.user;
				if (activateUser) {
					const payload = Object.assign({}, JSON.parse(activateUser), {
						firebaseUserId: emailauthuser.uid,
						email: emailauthuser.email,
					});
					dispatch(userActions.createUser(payload));
				}
			} else {
				const preventUserSignout = localStorage.getItem("preventUserSignout");
				if (preventUserSignout && preventUserSignout === "true") {
					localStorage.removeItem("preventUserSignout");
				} else {
					dispatch(authActions.logoutUser("No Account Found"));
				}
			}
			// TODO if user logs in and doesn't have a vessel account we need to figure out where to send them?
		} else {
			dispatch(controlPanelActions.displayError(action.error.message));
		}
		done();
	},
});

export default [getUserFailLogic];
